export default "__VITE_ASSET__D1_CMyK0__"